export function formatNumber(value) {
    if (typeof value === 'number') {
        return value.toLocaleString('ru-RU');
    }
    // Если строка, но это число
    if (!isNaN(value) && value !== '' && value !== null) {
        return Number(value).toLocaleString('ru-RU');
    }
    return value;
}